import { useNavigate } from 'react-router-dom';
import { INoticeType } from '../../pages/Notice/Notice';
import styles from './NoticeFrame.module.scss';
function NoticeFrame(props: { notice: INoticeType }) {
  const navigate = useNavigate();
  return (
    <div
      className={styles.container}
      onClick={() =>
        navigate(`/notice/${props.notice.id}`, { state: props.notice })
      }
    >
      <span className={styles.title}>{props.notice.title}</span>
      <span className={styles.date}>
        {props.notice.start_at.substring(0, 10).replace(/-/gi, '.')}
      </span>
    </div>
  );
}
export default NoticeFrame;
